import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AppLayout from '../components/work/AppLayout';
import InitiativeDetail from '../components/work/InitiativeDetail';
import Peek from '../components/work/Peek';
import { fetchInitiativeWorkspace } from '../lib/initiatives';

export default function InitiativePage() {
  const { workItemId } = useParams<{ workItemId: string }>();
  const [projectId, setProjectId] = useState<string | undefined>();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchInitiativeWorkspace()
      .then((workspace) => {
        if (!cancelled) setProjectId(workspace.project.id);
      })
      .catch((err: unknown) => {
        if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to open Initiatives');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <AppLayout>
      <InitiativeDetail projectId={projectId} workItemId={workItemId} error={error} />
      <Peek />
    </AppLayout>
  );
}
